import { CircleNotch } from "@phosphor-icons/react";
import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, booting } = useAuth();
  const location = useLocation();
  // Stable state object: avoids passing a new inline object to <Navigate>
  // on every render.
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (booting || user === undefined) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white" data-testid="route-loading">
        <CircleNotch size={28} className="animate-spin text-[#032852]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={redirectState} replace />;

  if (adminOnly && user.role !== "administrator" && user.role !== "global_administrator")
    return <Navigate to="/dashboard" replace />;

  return children;
}
